import {
    HealingOutlined,
    InsightsOutlined,
    ScheduleOutlined
} from '@mui/icons-material';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/root-treatment.jpg';
const secondaryImage = '/img/about-nerve-therapy.jpg';
const visitFrequencyImage = '/treatments/how_often_should_you_visit.webp';

const Treatments = () => (
    <DocPageLayout
        currentRoute="/treatments"
        pageLabel="TREATMENT"
        pageTitle="自然治癒力を引き出す当院の施術"
        heroImage={heroImage}
        heroImageAlt="施術の様子"
        heroHighlight="神経にアプローチし、根本から改善へ"
        heroDescription="オーダーメイドで組み合わせる神経整体と鍼灸施術で、不調の原因と再発予防に向き合います。"
    >
        <article className="doc-section">
            <h3 className="doc-section__title">
                <InsightsOutlined className="doc-section__icon" />治るメカニズム
            </h3>
            <div className="doc-section__body">
                <p>
                    人が本来持つ「自然治癒力」が身体を治し、痛みから解放する力になると考えています。その働きの中心となるのが神経です。
                </p>
                <p>
                    神経の働きが低下すると、身体がうまく調整できず様々な不調や痛みが現れます。原因としては身体の歪みや誤った使い方、精神的ストレスなどが挙げられ、神経の伝達異常や自律神経の乱れを招きます。
                </p>
                <p>
                    当院では神経の働きを整え、自然治癒力を高めることで不調を改善へ導きます。痛みが出ている部位にとらわれず、全身のバランスと連動性を重視します。
                </p>
                <p>
                    身体だけでなく心とのつながりも大切にし、心身ともに健康な状態を目指してサポートいたします。
                </p>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="神経整体の様子" loading="lazy" />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <HealingOutlined className="doc-section__icon" />当院の施術
            </h3>
            <ul className="doc-list">
                <li>
                    <InsightsOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>オーダーメイド治療</strong>
                        100人いれば原因は100通り。体質や症状に合わせて刺激の強さや施術方法を調整し、最適な組み合わせをご提案します。
                    </span>
                </li>
                <li>
                    <HealingOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>神経への直接アプローチ</strong>
                        鍼灸治療や神経整体など、神経に働きかける施術で伝達異常や自律神経の乱れにアプローチします。
                    </span>
                </li>
                <li>
                    <ScheduleOutlined className="doc-list__icon" />
                    <span className="doc-list__content">
                        <strong>身体の使い方・生活習慣の改善</strong>
                        誤った身体の使い方やストレス、生活習慣を見直し、再発しにくい身体づくりをサポートします。
                    </span>
                </li>
            </ul>
            <p className="doc-note">
                これらを組み合わせることで、どこへ行っても良くならなかった慢性的な症状に向き合います。
            </p>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <ScheduleOutlined className="doc-section__icon" />来院頻度の目安
            </h3>
            <div className="doc-section__body">
                <div className="doc-section__media doc-section__media--full doc-section__media--plain">
                    <img
                        src={visitFrequencyImage}
                        alt="来院頻度の目安"
                        loading="lazy"
                    />
                </div>
                <p>
                    症状や状態によって頻度は異なります。症状の程度や改善段階に応じてご相談しながら、最も効果的なタイミングをご提案いたします。
                </p>
                <p className="doc-note">
                    ご相談の上、無理なく通えるペースを一緒に検討いたします。
                </p>
            </div>
        </article>
    </DocPageLayout>
);

export default Treatments;

